// @flow strict

export const denseIconSize = 28;
export const denseIconPadding = 4;
export const regularIconPadding = 6;
export const regularIconSize = 36;
